import { useAuth } from '@/contexts/auth-context';
import { Button } from '@/components/ui/button';
import { LogOut, Home } from 'lucide-react';
import { Link } from 'wouter';

export default function UnauthorizedPage() {
  const { logout, user } = useAuth();

  return (
    <div className="min-h-screen flex items-center justify-center bg-surface-2">
      <div className="text-center max-w-md p-8 bg-white rounded-lg shadow-md">
        <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
          <svg
            className="w-8 h-8 text-red-600"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
            />
          </svg>
        </div>

        <h1 className="text-h1 text-ink mb-2">Unauthorized Access</h1>
        <p className="text-soft mb-6">
          You don't have permission to access this page.
        </p>

        {user && (
          <p className="text-sm text-soft mb-6">
            Logged in as: <span className="font-medium">{user.email}</span>
            <br />
            Role: <span className="font-medium capitalize">{user.role}</span>
          </p>
        )}

        <div className="flex flex-col gap-3">
          <Link href="/">
            <Button variant="outline" className="w-full">
              <Home className="w-4 h-4 mr-2" />
              Go to Homepage
            </Button>
          </Link>

          <Button
            onClick={logout}
            variant="default"
            className="w-full"
          >
            <LogOut className="w-4 h-4 mr-2" />
            Logout and Try Another Account
          </Button>
        </div>
      </div>
    </div>
  );
}

export function NotFoundPage() {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <h1 className="text-display-sm text-ink">404</h1>
        <p className="mt-2">Page not found</p>
      </div>
    </div>
  );
}
